export default __webpack_public_path__ + "static/media/CircleTickMark.c4b2ddaa.svg";